
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1971"}},[_c('path',{attrs:{"data-name":"Rectangle 2699","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1970"}},[_c('g',{attrs:{"data-name":"Group 1968"}},[_c('path',{attrs:{"data-name":"Path 1295","d":"M1.004 23V9a1.13 1.13 0 01.387-.723l10.336-6.891a.669.669 0 01.554 0l10.336 6.891a1.13 1.13 0 01.387.723l-.006 14z","fill":"#f9a36c"}}),_c('path',{attrs:{"data-name":"Path 1296","d":"M12 2.404l9.983 6.655.017.031L21.994 22H2.004V9.09l.017-.031 9.983-6.655m0-2.078a1.525 1.525 0 00-.832.228L.836 7.445A2.1 2.1 0 00.004 9v14a1 1 0 001 1h21.99a1 1 0 001-1L24 9a2.1 2.1 0 00-.832-1.555L12.832.554A1.523 1.523 0 0012 .326z"}})]),_c('g',{attrs:{"data-name":"Group 1969","transform":"translate(-208.456 -307.174)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2700","width":"4","height":"4","rx":"1","transform":"translate(215.568 316.268)"}}),_c('rect',{attrs:{"data-name":"Rectangle 2701","width":"4","height":"4","rx":"1","transform":"translate(221.568 322.268)"}}),_c('circle',{attrs:{"data-name":"Ellipse 251","cx":"2","cy":"2","r":"2","transform":"translate(215.568 322.268)"}}),_c('circle',{attrs:{"data-name":"Ellipse 252","cx":"2","cy":"2","r":"2","transform":"translate(221.693 316.268)"}})])])])])
          )
        }
      }
    